<template>
  <!--Program-->
  <section>
    <div class="container" v-if="isReady">
      <div class="row">
        <div class="col-md-12 col-12">
          <div class="box p-4">
            <h2 class="title text-center mb-4">Bilimsel Program</h2>
            <div class="stage-picker mb-4">
              <b-button
                size="lg"
                variant="outline-primary"
                @click="pickStage(stages[0])"
                >6 Aralık PAZARTESİ</b-button
              >
              <b-button
                size="lg"
                variant="outline-primary"
                @click="pickStage(stages[1])"
                >7 Aralık SALI</b-button
              >
              <b-button
                size="lg"
                variant="outline-primary"
                @click="pickStage(stages[2])"
                >8 Aralık ÇARŞAMBA</b-button
              >
            </div>
            <ul class="program">
              <!--Item-->
              <li
                class="d-flex p-3"
                v-for="session in sessionList"
                :key="session.id"
              >
                <div class="right">
                  <div class="session-time">
                    <img class="time" src="@/assets/images/time.svg" alt="" />
                    {{ session.start | moment("HH:mm") }} -
                    {{ session.end | moment("HH:mm") }}
                    <b-badge
                      variant="danger"
                      v-if="session.isLive"
                      style="
                        color: #fff;
                        display: block;
                        padding: 0.4rem;
                        width: 40px;
                      "
                      >Live</b-badge
                    >
                  </div>
                </div>
                <div class="left">
                  <div>
                    <div class="title">{{ session.title }}</div>

                    <span
                      class="description"
                      v-if="session.description"
                      v-html="session.description"
                    ></span>
                  </div>
                  <span class="sponsor" v-if="session.sponsorLogo">
                    <img :src="session.sponsorLogo" />
                  </span>
                </div>
              </li>

              <!--Item
              <li class="d-flex mb-3">
                <div>09:00 - 10:00</div>
                <div>
                  <p>Açılış Konuşması</p>
                  <span>Dr. Barış Ökçün</span>
                  <small
                    >İstanbul Üniversitesi Cerrahpaşa Kardiyoloji Enstitüsü -
                    İstanbul</small
                  >
                </div>
              </li>
              -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { stages } from '@/config';

export default {
  name: 'StageList',
  components: {},
  data() {
    return {
      isReady: false,
      selectedStage: null,
      stages,
    };
  },
  computed: {
    ...mapGetters({
      sessionList: 'agenda/list',
      loading: 'agenda/loading',
      schema: 'agenda/schema',
      currentEventPath: 'event/currentPath',
      currentEvent: 'event/current',
    }),
    sessionPath() {
      return `${this.currentEventPath}/stage/${this.selectedStage}/session`;
    },
  },
  methods: {
    ...mapActions({
      setCurrent: 'agenda/setCurrent',
      findAgenda: 'agenda/find',
      clearState: 'agenda/clearItems',
    }),
    getAgenda() {
      this.clearState();
      return this.findAgenda({
        path: this.sessionPath,
        subscribe: true,
        order: { field: 'start', desc: false },
      }).then(() => {});
    },
    pickStage(stageId) {
      this.selectedStage = stageId;
      this.getAgenda();
    },
  },
  created() {
    this.selectedStage = this.currentEvent.defaultStage;
    this.getAgenda().then(() => {
      this.isReady = true;
    });
  },
};
</script>

<style lang="scss">
.session-time {
  font-weight: bold;
  font-size: 14px;
  padding-right: 3rem;
  border-right: 2px solid #b60016;

  img.time {
    width: 16px;
    opacity: 0.3;
    margin-top: -3px;
  }
}

.stage-picker {
  display: flex;
  justify-content: center;
  margin: auto;
  button {
    font-size: 12px;
    font-weight: bold;
    margin-left: 4px;
  }
}

.sponsor {
  width: 160px;
  position: absolute;
  display: block;
  margin-left: 0px;
  margin-top: 30px;
  right: 60px;
  img {
    object-fit: contain;
  }
}
</style>
